import type {
  GetAdministratorsResponse,
  GetSchemesResponse,
} from '@quromedical/models';
import { trpcClient } from 'trpc';

export class MedicalAidApi {
  public async getAdministrators(): Promise<GetAdministratorsResponse> {
    const result = await trpcClient.administrator.getAll.query();

    return result;
  }

  public async getSchemes(): Promise<GetSchemesResponse> {
    const result = await trpcClient.scheme.getAll.query();

    return result;
  }
}
